import dayjs from "dayjs";
import type { FC, RefObject } from "react";
import { EmailCard } from "../../../../../components/EmailCard/EmailCard";
import type { EmailSearchInput } from "../../../../../hooks/useEmailsRestApi";
import type { EmailWithStatus } from "../..";

export type MatterEmailsCardsUIProps = {
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
};

export const MatterEmailsCardsUI: FC<MatterEmailsCardsUIProps> = ({
  emails,
  onSelectEmail,
  currentSearchInput,
  scrollCardRef,
  scrollCardId,
}) => {
  if (emails.length === 0) {
    return (
      <div className="flex justify-center">
        <div className="text-left text-gray-500 max-w-xl">
          <p>条件に合う検索結果はありません。</p>
          <div className="h-4" />
          <p>あるいは、あなたのアカウントがどの会社にも紐づいていません。</p>
          <p>管理者にアカウントと所属会社の紐づけ作業を依頼してください。</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {emails.map(email => (
        <EmailCard
          key={email.id}
          isMatter={true}
          emailId={email.id}
          onSelectEmail={onSelectEmail}
          title={email.subject}
          date={dayjs(email.date).toString()}
          period={email.matterColumn?.period || null}
          content={email.content}
          reward={email.matterColumn?.reward || null}
          isRemoteEnabled={email.matterColumn?.isRemoteEnabled || false}
          station={email.matterColumn?.station || null}
          numberOfInterviews={email.matterColumn?.numberOfInterviews || null}
          otherCountriesEnabled={
            email.matterColumn?.otherCountriesEnabled || false
          }
          onlyEnableFreelance={
            currentSearchInput.matterFilter?.onlyEnableFreelance || false
          }
          workingTimeWidth={email.matterColumn?.workingTimeWidth || null}
          endOrPrimeContractorDirect={
            email.matterColumn?.endOrPrimeContractorDirect || null
          }
          depth={email.matterColumn?.depth ?? null}
          technology={email.matterColumn?.technology || null}
          industryCategory={email.matterColumn?.industryCategory || null}
          remoteFrequency={email.matterColumn?.remoteFrequency || null}
          isRead={email.read}
          hasAttachments={email.hasAttachments}
          duplicateCount={email.duplicateCount}
          originalMessageId={email.originalMessageId}
          scrollCardRef={scrollCardRef}
          scrollCardId={scrollCardId}
        />
      ))}
    </div>
  );
};
